var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "panel", attrs: { id: "panel-4" } }, [
        _c("div", { staticClass: "panel-hdr" }, [
          _c("h2", [
            _vm._v("\n                    " + _vm._s(_vm.__t("LIST")) + " "),
            _c("span", { staticClass: "fw-300" }, [
              _c("i", [_vm._v(_vm._s(_vm.__t("MODIFIES")))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-toolbar" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed",
                on: { click: _vm.create },
              },
              [_c("i", { staticClass: "fal fa-plus" })]
            ),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn btn-panel waves-effect waves-themed",
              attrs: {
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-container show" }, [
          _c(
            "div",
            { staticClass: "panel-content" },
            [
              _c(
                "div",
                { staticClass: "filter_block mb-3" },
                [_c("filter_modificators")],
                1
              ),
              _vm._v(" "),
              _vm.is_load
                ? _c("b-skeleton-table", {
                    attrs: {
                      rows: this.cur_records,
                      columns: 2,
                      "hide-header": true,
                      "table-props": { bordered: false, striped: true },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.is_load
                ? _c(
                    "div",
                    { staticClass: "inbox_vue_list" },
                    [
                      _vm.rows.length > 0
                        ? _c(
                            "div",
                            { staticClass: "inb_pagi pt-4" },
                            [
                              _c("pagination_list", {
                                key: "up",
                                attrs: {
                                  total: _vm.pagination.total,
                                  limit: _vm.pagination.limit,
                                  current: _vm.pagination.pagesCurrent,
                                },
                                on: { "page-change": _vm.handlePageChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rows.length > 0
                        ? _c("b-table", {
                            staticClass: "table-responsive-xl resolution_table",
                            attrs: {
                              "tbody-tr-class": _vm.rowClass,
                              striped: "",
                              items: _vm.rows,
                              fields: _vm.fields,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head(id)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "status_info",
                                          staticStyle: { "max-width": "50px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.__t("STATUS")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(ordering)",
                                  fn: function (data) {
                                    return [
                                      _c("grid_list", {
                                        attrs: {
                                          list_ordering: "ordering",
                                          field_name: _vm.__t("ORDERING"),
                                          current_ordering: _vm.list.ordering,
                                          current_direction: _vm.list.direction,
                                        },
                                        on: {
                                          "update-order": _vm.handleOrdering,
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "head(uniq_id)",
                                  fn: function (data) {
                                    return [
                                      _c("grid_list", {
                                        attrs: {
                                          list_ordering: "uniq_id",
                                          field_name: _vm.__t("UNIQ_ID"),
                                          current_ordering: _vm.list.ordering,
                                          current_direction: _vm.list.direction,
                                        },
                                        on: {
                                          "update-order": _vm.handleOrdering,
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "head(title)",
                                  fn: function (data) {
                                    return [
                                      _c("grid_list", {
                                        attrs: {
                                          list_ordering: "name",
                                          field_name: _vm.__t("TTILE"),
                                          current_ordering: _vm.list.ordering,
                                          current_direction: _vm.list.direction,
                                        },
                                        on: {
                                          "update-order": _vm.handleOrdering,
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "head(added)",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.__t("DATE")) +
                                          "\n                            "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(id)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-control custom-checkbox",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: data.item.published,
                                                expression:
                                                  "data.item.published",
                                              },
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              name: "cid[]",
                                              type: "checkbox",
                                              id: data.item.id + "_cust_id",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                data.item.published
                                              )
                                                ? _vm._i(
                                                    data.item.published,
                                                    null
                                                  ) > -1
                                                : data.item.published,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.save_modif_publish(
                                                  data.item
                                                )
                                              },
                                              change: function ($event) {
                                                var $$a = data.item.published,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        data.item,
                                                        "published",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        data.item,
                                                        "published",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    data.item,
                                                    "published",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("label", {
                                            staticClass:
                                              "custom-control-label cursor-pointer bolder",
                                            attrs: {
                                              for: data.item.id + "_cust_id",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(ordering)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn btn-primary btn-icon rounded-circle position-relative js-waves-off",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fal fa-sort",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge border border-light rounded-pill bg-danger-500 position-absolute pos-top pos-right",
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t    " +
                                                  _vm._s(data.item.ordering) +
                                                  "\n\t\t\t\t\t\t\t\t    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(uniq_id)",
                                  fn: function (data) {
                                    return [
                                      _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-start w-100 fs-xl mb-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.open_item(
                                                      data.item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "base base-15 icon-stack-3x opacity-100 color-primary-900",
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fal fa-indent icon-stack-1x opacity-100 color-white",
                                                }),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(data.item.uniq_id) +
                                                "\n\n                                        "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "small text-info pl-2",
                                              },
                                              [
                                                data.item.skeep_sync
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fal fa-lock",
                                                      attrs: {
                                                        title:
                                                          _vm.__t(
                                                            "MOD_SKIP_SYNC"
                                                          ),
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                data.item.hidden
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fal fa-user-ninja",
                                                      attrs: {
                                                        title:
                                                          _vm.__t("MOD_HIDDEN"),
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            data.item.is_product
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "color-danger-700 ml-4",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fal fa-barcode-read",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-start w-100",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "small badge border border-success",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(data.item.price) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.obj_to_null(data.item.group)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ml-3 small badge border border-info",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          data.item.group.title
                                                        ) +
                                                        "\n\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(price)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "prod_price bold color-primary-900 mt-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                new Intl.NumberFormat(
                                                  "ru-RU"
                                                ).format(
                                                  parseFloat(data.item.price)
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                          _c("span", {
                                            staticClass:
                                              "woocommerce-Price-currencySymbol fs-sm",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(title)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "prod_name fs-xl color-success-600",
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.nice_search(data.item.name)
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small text-info pl-2",
                                            },
                                            [
                                              data.item.skeep_sync
                                                ? _c("i", {
                                                    staticClass: "fal fa-lock",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "small badge border border-warning",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        ID: " +
                                                _vm._s(data.item.id) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "categ_name" }, [
                                        _vm.obj_to_null(data.item.address)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "small badge border border-primary text-primary",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(data.item.address) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3776736993
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rows.length > 0
                        ? _c(
                            "div",
                            { staticClass: "inb_pagi pt-4" },
                            [
                              _c("pagination_list", {
                                key: "down",
                                attrs: {
                                  total: _vm.pagination.total,
                                  limit: _vm.pagination.limit,
                                  current: _vm.pagination.pagesCurrent,
                                },
                                on: { "page-change": _vm.handlePageChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("modif_modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }